import Modal from "./modal";

export default class StakeholderModal extends Modal {
  constructor(isPage = false) {
    super("stakeholders-modal");
    this.isPage = isPage;
    this.$idField = this.$form.querySelector('[name="id"]');
    this.cb = null;
    this.stakeholderList = [];
    this.representativesCollapsable = this.$form.querySelector(
      '[data-bs-target="#representatives-container"]'
    );

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "name",
        varType: "string",
        required: true,
      },
      {
        name: "surnames",
        varType: "string",
      },
      {
        name: "email",
        varType: "string",
      },
      {
        name: "civil_status",
        varType: "string",
      },
      {
        name: "group",
        varType: "string",
      },
      {
        name: "street",
        varType: "string",
      },
      {
        name: "street2",
        varType: "string",
      },
      {
        name: "postal_code",
        varType: "string",
      },
      {
        name: "city",
        varType: "string",
      },
      {
        name: "country",
        varType: "int",
      },
      {
        name: "identifier",
        varType: "string",
      },
      {
        name: "custom_identifier",
        varType: "string",
      },
      {
        name: "type",
        varType: "radio",
        trigger: "change",
      },
      {
        name: "phone",
        varType: "string",
      },
      {
        name: "birth_date",
        varType: "string",
      },
      {
        name: "nationality",
        varType: "int",
      },
      {
        name: "custom_fields",
        varType: "string",
      },
      {
        name: "notes",
        varType: "string",
      },
    ];

    this.setupCountries().then(() => {
      this.whenReady();
    });
    this.setupModalListeners();
  }

  whenReady() {
    super.whenReady();
    this.showRepresentatives();
    // reset person/entity tab
    this.$form
      .querySelectorAll('[type="radio"]:not(:checked) + label.active')
      .forEach((label) => {
        label.classList.remove("active");
      });
  }

  setupCountries() {
    return new Promise((resolve, reject) => {
      peque.api("countries", { sorted: true}).then((response) => {
        const $country = this.$form.querySelector('[name="country"]');
        const $nationality = this.$form.querySelector('[name="nationality"]');

        response.result.list.forEach((country) => {
          const el = document.createElement("option");
          el.innerText = country.name;
          el.value = country.id;
          $country.appendChild(el);

          // can't be reused easily :(
          const el2 = document.createElement("option");
          el2.innerText = country.name;
          el2.value = country.id;
          $nationality.appendChild(el2);
        });
        // set company's country by default
        $country.value = window.currentCompany.country;
        $nationality.value = window.currentCompany.country;

        new AutocompleteSelect($country, {
          inputClasses: ["form-control"],
          dropdownClasses: ["border"],
          limit: 500,
        });
        new AutocompleteSelect($nationality, {
          inputClasses: ["form-control"],
          dropdownClasses: ["border"],
          limit: 500,
        });
        resolve();
      });
    });
  }

  setupModalListeners() {
    document.querySelectorAll('[name="type"]').forEach((el) => {
      el.addEventListener("change", () => {
        if (!el.checked) {
          return;
        }
        const stakeholderType = parseInt(el.value);
        document.querySelectorAll("[data-person-child]").forEach((child) => {
          child.style.display =
            stakeholderType === peque.STAKEHOLDER_TYPE_PERSON
              ? "block"
              : "none";
        });
        document.querySelectorAll("[data-entity-child]").forEach((child) => {
          child.style.display =
            stakeholderType === peque.STAKEHOLDER_TYPE_PERSON
              ? "none"
              : "block";
        });
      });
    });

    const $syncButton = this.$form.querySelector('[data-action="sync-data"]');
    if ($syncButton) {
      $syncButton.addEventListener("click", async () => {
        $syncButton.children[0].classList.add("fa-spin");
        $syncButton.setAttribute("disabled", "disabled");
        await this.syncData();
        $syncButton.children[0].classList.remove("fa-spin");
        $syncButton.removeAttribute("disabled");
      });
    }

    this.$form
      .querySelector('[data-action="add-representative"]')
      .addEventListener("change", () => {
        let representativeId = this.getField("representative-name").value;
        if (!representativeId) {
          return;
        }
        representativeId = parseInt(representativeId);
        const name = document.querySelector(
          '[name="representative-name"] option:checked'
        ).innerText;
        this.addRepresentative(name, representativeId);
        this.getField("representative-name").value = "";
      });

    this.$form
      .querySelector('[data-bs-target="#representatives-container"]')
      .addEventListener("click", () => {
        this.setupStakeholders();
      });

    if (this.isPage) {
      this.$form
        .querySelectorAll('[data-bs-toggle="collapse"]')
        .forEach((el) => {
          if (el.style?.display !== "none") {
            el.click();
          }
        });
    } else {
      this.$form
        .querySelector('[name="email"]')
        .parentElement.parentElement.classList.remove("d-none");
      this.$form
        .querySelector('[name="group"]')
        .parentElement.classList.remove("d-none");
      document.getElementById("basic-info").classList.remove("d-none");
      const internalNoteBtn = this.$form.querySelector(
        '[data-bs-target="#notes-container"]'
      );
      internalNoteBtn.classList.remove("d-none");
      internalNoteBtn.nextElementSibling.classList.remove("d-none");
      const customFieldsContainer = this.$form.querySelector(
        '[data-bs-target="#custom-fields-container"]'
      );
      customFieldsContainer.classList.remove("d-none");
      customFieldsContainer.nextElementSibling.classList.remove("d-none");
    }
  }

  async addRepresentative(name, representativeId) {
    if (this.currentData === null) {
      this.currentData = {};
    }
    if (
      typeof this.currentData.representatives === "undefined" ||
      this.currentData.representatives === null
    ) {
      this.currentData.representatives = [];
    }
    if (!this.currentData.representatives.includes(representativeId)) {
      this.currentData.representatives.push(representativeId);
    }
    this.showRepresentative(name, representativeId);
  }

  async removeRepresentative(representativeId, template) {
    const index = this.currentData.representatives.indexOf(representativeId);
    if (index === -1) {
      return;
    }
    this.currentData.representatives.splice(index, 1);
    template.remove();
  }

  showRepresentative(name, representativeId) {
    if (
      this.isPage ||
      document.getElementById("stakeholder-representative-" + representativeId)
    ) {
      return;
    }
    const template = peque.parseTemplate("stakeholder-representative", {
      name: name,
      id: representativeId,
    });

    template
      .querySelector('[data-action="remove-representative"]')
      .addEventListener("click", () => {
        this.removeRepresentative(representativeId, template);
      });

    document
      .querySelector("#representatives-container ul.list-group")
      .append(template);
  }

  async setupStakeholders() {
    const $stakeholderSelect = this.getField("representative-name");

    if (typeof this.stakeholderAutocomplete !== "undefined") {
      return;
    }

    const response = await peque.api(
      "stakeholders",
      { company: window.currentCompany.id },
      "get"
    );
    this.stakeholderList = response.result.list;
    response.result.list.forEach((entry) => {
      if (entry.type === peque.STAKEHOLDER_TYPE_ENTITY) {
        return;
      }
      const el = document.createElement("option");
      el.innerText = entry.fullName;
      el.value = entry.id;
      el.dataset.type = entry.type;
      $stakeholderSelect.appendChild(el);
    });

    const autocompleteOptions = {
      inputClasses: ["form-control"],
      dropdownClasses: ["border"],
      allowHTML: true,
    };
    this.stakeholderAutocomplete = new AutocompleteSelect(
      $stakeholderSelect,
      autocompleteOptions
    );

    if (this.currentData && this.currentData.representatives) {
      this.showRepresentatives();
    }
  }

  showRepresentatives() {
    document.querySelector(
      "#representatives-container ul.list-group"
    ).innerHTML = "";

    if (
      this.stakeholderList.length < 1 ||
      !this.currentData ||
      !this.currentData.representatives
    ) {
      return;
    }

    this.currentData.representatives.forEach((id) => {
      const stakeholder = this.stakeholderList.find((s) => s.id === id);
      this.showRepresentative(stakeholder.fullName, id);
    });
  }

  async syncData() {
    const email = this.getString("email");

    if (email.length < 1) {
      return;
    }

    const stakeholders = (
      await peque.api(
        "stakeholders/global_search",
        { email, company: window.currentCompany.id },
        "get"
      )
    ).result.list;

    stakeholders.forEach((stakeholder) => {
      // skip the current company as we want data from any other
      if (stakeholder.company === window.currentCompany.id) {
        return;
      }
      if (stakeholder.name) {
        delete stakeholder.id;
        delete stakeholder.company;
        delete stakeholder.uid;
        this.prefillForm(stakeholder, this.formFields);
      }
    });
  }

  setCallback(cb) {
    this.cb = cb;
  }

  getId() {
    return this.$idField.value;
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);
    const type = this.getBoolean("type");
    let representatives = [];

    if (type === peque.STAKEHOLDER_TYPE_ENTITY && this.currentData) {
      representatives = this.currentData.representatives;
    }

    let data = {
      id: parseInt(this.$idField.value) || null,
      company: window.currentCompany.id,
      name: this.getString("name"),
      surnames: this.getString("surnames"),
      email: this.getString("email"),
      civil_status: this.getString("civil-status"),
      group: this.getString("group"),
      street: this.getString("street"),
      street2: this.getString("street2"),
      postal_code: this.getString("postal-code"),
      city: this.getString("city"),
      country: this.getInt("country"),
      identifier: this.getString("identifier"),
      custom_identifier: this.getString("custom-identifier"),
      type: type,
      phone: this.getInt("phone"),
      birth_date: this.getString("birth-date"),
      nationality: this.getInt("nationality"),
      custom_fields: this.getString("custom-fields"),
      notes: this.getString("notes"),
      representatives: representatives,
    };

    if (this.isPage) {
      // Send a request
      const modifiedValues = this.getFormModifiedFields(data);

      peque
        .api(
          "change_requests/bulk",
          JSON.stringify({
            company: data.company,
            affected_table: "stakeholders",
            affected_id: data.id,
            changes: Object.entries(modifiedValues).reduce(
              (current, [field, { newValue }]) => {
                return { ...current, [field]: newValue };
              },
              {}
            ),
          }),
          "post"
        )
        .then(() => {
          this.enableSubmitButton(true);
          peque.navigation.showSuccess(trans("your_request_has_been_sent"));
        })
        .catch(() => {
          this.enableSubmitButton(true);
          peque.navigation.showError(trans("your_request_could_not_be_sent"));
        });
    } else {
      // Modify stakeholder
      peque
        .api("stakeholders" + (data.id ? "/" + data.id : ""), data, "post")
        .then((response) => {
          if (typeof this.cb !== "undefined" && this.cb != null) {
            this.cb(response.result);
            this.enableSubmitButton(true);
          } else {
            location.reload();
          }
        })
        .catch((response) => {
          this.enableSubmitButton(true);

          switch (response.error) {
            case peque.ERROR_DUPLICATED_ENTRY:
              if (response.field && response.field === "identifier") {
                peque.navigation.showError(
                  trans(
                    "you_cannot_assign_multiple_stakeholders_to_the_same_identifier"
                  )
                );
              } else if(data.type === 2) {
                peque.navigation.showError(
                    trans("you_cannot_assign_multiple_stakeholders_to_the_same_email_use_representatives_field")
                )
              } else {
                peque.navigation.showError(
                  trans(
                    "you_cannot_assign_multiple_stakeholders_to_the_same_email"
                  )
                );
              }
              break;
            case peque.ERROR_UPGRADE_PLAN:
              peque.showLimitReachedModal("stakeholder-limit");
              break;
          }
        });
    }
  }
}
